import React, { useState } from 'react';
import './BuscaLeads.css';
import EstadoCarregando from './EstadoCarregando';
import EstadoVazio from './EstadoVazio';
import { apiFetch, ApiError } from './api';

function BuscaLeads({ onNavegar }) {
  // Estados para gerenciar a busca e seus resultados
  const [carregando, setCarregando] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [fonteBusca, setFonteBusca] = useState('inpi');
  const [erro, setErro] = useState(null);
  const [termoBusca, setTermoBusca] = useState('');
  const [filtroRegiao, setFiltroRegiao] = useState('');
  const [filtroTipoEmpresa, setFiltroTipoEmpresa] = useState('');
  const [filtroCnae, setFiltroCnae] = useState('');
  const [filtroDataRegistro, setFiltroDataRegistro] = useState('');
  const [filtroClasse, setFiltroClasse] = useState('');
  const [modalConversaoAberto, setModalConversaoAberto] = useState(false);
  const [leadAtual, setLeadAtual] = useState(null);
  const [leadsConvertidos, setLeadsConvertidos] = useState([]);
  const [clientesConvertidos, setClientesConvertidos] = useState({}); // leadId -> clienteId (deeplink)
  const [documentoConversao, setDocumentoConversao] = useState('');
  const [observacoesConversao, setObservacoesConversao] = useState('');
  const [erroConversao, setErroConversao] = useState(null);
  const [convertendo, setConvertendo] = useState(false);
  const [mostrarFiltrosAvancados, setMostrarFiltrosAvancados] = useState(false);
  const [mostrarDescartados, setMostrarDescartados] = useState(false);
  const [statusEmAndamento, setStatusEmAndamento] = useState(null); // leadId em ação de status
  const [erroStatus, setErroStatus] = useState(null); // { leadId, mensagem }
  // Conversão em lote (PRD 22 / SEF-30, US-002): seleção separada dos resultados.
  const [selecionados, setSelecionados] = useState([]); // leadIds selecionados
  const [modalLoteAberto, setModalLoteAberto] = useState(false);
  const [documentosLote, setDocumentosLote] = useState({}); // leadId -> documento digitado
  const [enviandoLote, setEnviandoLote] = useState(false);
  const [resultadosLote, setResultadosLote] = useState(null); // [{ leadId, success, clienteId, erro }]
  const [erroLote, setErroLote] = useState(null);

  // Lista de estados brasileiros para o filtro
  const estadosBrasileiros = [
    { sigla: 'AC', nome: 'Acre' },
    { sigla: 'AL', nome: 'Alagoas' },
    { sigla: 'AP', nome: 'Amapá' },
    { sigla: 'AM', nome: 'Amazonas' },
    { sigla: 'BA', nome: 'Bahia' },
    { sigla: 'CE', nome: 'Ceará' },
    { sigla: 'DF', nome: 'Distrito Federal' },
    { sigla: 'ES', nome: 'Espírito Santo' },
    { sigla: 'GO', nome: 'Goiás' },
    { sigla: 'MA', nome: 'Maranhão' },
    { sigla: 'MT', nome: 'Mato Grosso' },
    { sigla: 'MS', nome: 'Mato Grosso do Sul' },
    { sigla: 'MG', nome: 'Minas Gerais' },
    { sigla: 'PA', nome: 'Pará' },
    { sigla: 'PB', nome: 'Paraíba' },
    { sigla: 'PR', nome: 'Paraná' },
    { sigla: 'PE', nome: 'Pernambuco' },
    { sigla: 'PI', nome: 'Piauí' },
    { sigla: 'RJ', nome: 'Rio de Janeiro' },
    { sigla: 'RN', nome: 'Rio Grande do Norte' },
    { sigla: 'RS', nome: 'Rio Grande do Sul' },
    { sigla: 'RO', nome: 'Rondônia' },
    { sigla: 'RR', nome: 'Roraima' },
    { sigla: 'SC', nome: 'Santa Catarina' },
    { sigla: 'SP', nome: 'São Paulo' },
    { sigla: 'SE', nome: 'Sergipe' },
    { sigla: 'TO', nome: 'Tocantins' }
  ];

  // Lista de tipos de empresa para o filtro
  const tiposEmpresa = [
    { valor: 'mei', rotulo: 'Microempreendedor Individual (MEI)' },
    { valor: 'me', rotulo: 'Microempresa (ME)' },
    { valor: 'epp', rotulo: 'Empresa de Pequeno Porte (EPP)' },
    { valor: 'eireli', rotulo: 'Empresa Individual (EIRELI)' },
    { valor: 'ltda', rotulo: 'Sociedade Limitada (LTDA)' },
    { valor: 'sa', rotulo: 'Sociedade Anônima (S/A)' },
    { valor: 'startup', rotulo: 'Startup' }
  ];

  // Lista de principais CNAEs (Classificação Nacional de Atividades Econômicas)
  const principaisCnaes = [
    { codigo: '47.6', descricao: 'Comércio varejista de produtos culturais e recreativos' },
    { codigo: '56.1', descricao: 'Restaurantes e outros serviços de alimentação' },
    { codigo: '62.0', descricao: 'Atividades dos serviços de tecnologia da informação' },
    { codigo: '70.2', descricao: 'Atividades de consultoria em gestão empresarial' },
    { codigo: '73.1', descricao: 'Publicidade' },
    { codigo: '85.5', descricao: 'Atividades de apoio à educação' },
    { codigo: '86.3', descricao: 'Atividades de atenção ambulatorial' }
  ];

  // Lista de classes INPI para o filtro
  const classesINPI = [
    { numero: '1', descricao: 'Produtos químicos' },
    { numero: '3', descricao: 'Cosméticos e produtos de limpeza' },
    { numero: '5', descricao: 'Produtos farmacêuticos' },
    { numero: '9', descricao: 'Aparelhos e instrumentos científicos' },
    { numero: '25', descricao: 'Vestuário e calçados' },
    { numero: '35', descricao: 'Publicidade e gestão de negócios' },
    { numero: '41', descricao: 'Educação, entretenimento e atividades culturais' },
    { numero: '42', descricao: 'Serviços científicos e tecnológicos' },
    { numero: '43', descricao: 'Serviços de alimentação e hospedagem' }
  ];

  // Rótulo de exibição da fonte (o backend usa o token em minúsculas).
  const rotuloFonte = (fonte) => (
    { google: 'Google Maps', receita: 'Receita Federal', inpi: 'INPI' }[fonte] || fonte
  );

  // Zera a seleção/estado do lote (PRD 22 / SEF-30, US-002) — usado ao trocar a lista de resultados.
  const limparSelecaoLote = () => {
    setSelecionados([]);
    setDocumentosLote({});
    setResultadosLote(null);
    setErroLote(null);
  };

  // Busca real (PRD 21 / SEF-27): fonte INPI consulta o backend; google/receita ainda
  // bloqueadas (503 EXTERNAL_SOURCE_UNAVAILABLE) -> mensagem de produto, não erro genérico.
  const realizarBusca = async (descartadosOverride) => {
    if (carregando || !termoBusca.trim()) {
      return; // anti-duplo-submit + termo obrigatório
    }
    // nova busca troca a lista: descarta seleção/lote antigos (não converter lead fora de vista)
    limparSelecaoLote();
    const descartados = descartadosOverride !== undefined ? descartadosOverride : mostrarDescartados;
    setCarregando(true);
    setErro(null);
    try {
      const resposta = await apiFetch('/api/leads/buscar', {
        method: 'POST',
        body: { fonte: fonteBusca, termoBusca: termoBusca.trim(), mostrarDescartados: descartados },
      });
      setResultados(resposta?.leads ?? []);
    } catch (e) {
      setResultados([]);
      if (e instanceof ApiError && e.code === 'EXTERNAL_SOURCE_UNAVAILABLE') {
        setErro(`A fonte "${rotuloFonte(e.details?.fonte ?? fonteBusca)}" estará disponível em breve. `
          + 'Disponível agora: INPI.');
      } else if (e instanceof ApiError && e.status === 400) {
        setErro('Informe a fonte e um termo de busca.');
      } else {
        setErro('Não foi possível buscar leads. Tente novamente.');
      }
    } finally {
      setCarregando(false);
    }
  };

  // Função para limpar os filtros
  const limparFiltros = () => {
    setTermoBusca('');
    setFiltroRegiao('');
    setFiltroTipoEmpresa('');
    setFiltroCnae('');
    setFiltroDataRegistro('');
    setFiltroClasse('');
    setResultados([]);
    limparSelecaoLote();
    setErro(null);
  };

  // Função para abrir modal de conversão
  const abrirModalConversao = (lead) => {
    setLeadAtual(lead);
    setDocumentoConversao('');
    setObservacoesConversao('');
    setErroConversao(null);
    setModalConversaoAberto(true);
  };

  // Função para fechar modal de conversão
  const fecharModalConversao = () => {
    setModalConversaoAberto(false);
    setLeadAtual(null);
    setErroConversao(null);
  };

  // Converte o lead em cliente via POST /api/leads/{id}/converter (PRD 22 / SEF-30, US-001).
  // Documento é obrigatório (lead INPI não tem); a validação final de CPF/CNPJ é do backend.
  const converterLead = async () => {
    if (convertendo || !documentoConversao.trim()) {
      return; // anti-duplo-submit + documento obrigatório
    }
    const lead = leadAtual;
    setConvertendo(true);
    setErroConversao(null);
    try {
      const resp = await apiFetch(`/api/leads/${lead.id}/converter`, {
        method: 'POST',
        body: {
          documento: documentoConversao.trim(),
          observacoes: observacoesConversao.trim() || null,
        },
      });
      setLeadsConvertidos((prev) => [...prev, lead.id]);
      if (resp?.clienteId) {
        setClientesConvertidos((prev) => ({ ...prev, [lead.id]: resp.clienteId }));
      }
      // mantém badge e ações consistentes sem nova busca (review CTO #51)
      setResultados((prev) => prev.map((l) => (
        l.id === lead.id ? { ...l, status: 'convertido', clienteId: resp?.clienteId || l.clienteId } : l
      )));
      fecharModalConversao();
    } catch (e) {
      const cid = e instanceof ApiError ? e.details?.clienteId : null;
      if (e instanceof ApiError && e.code === 'ALREADY_CONVERTED') {
        setLeadsConvertidos((prev) => [...prev, lead.id]);
        if (cid) setClientesConvertidos((prev) => ({ ...prev, [lead.id]: cid }));
        setResultados((prev) => prev.map((l) => (
          l.id === lead.id ? { ...l, status: 'convertido', clienteId: cid || l.clienteId } : l
        )));
        setErroConversao('Este lead já foi convertido em cliente.');
      } else if (e instanceof ApiError && e.code === 'ALREADY_CLIENT') {
        if (cid) setClientesConvertidos((prev) => ({ ...prev, [lead.id]: cid }));
        setErroConversao('Este documento já é cliente do escritório.');
      } else if (e instanceof ApiError && e.status === 400) {
        setErroConversao('Informe um CPF/CNPJ válido.');
      } else {
        setErroConversao('Não foi possível converter. Tente novamente.');
      }
    } finally {
      setConvertendo(false);
    }
  };

  const abrirCliente = (leadId) => {
    const clienteId = clientesConvertidos[leadId];
    if (clienteId && onNavegar) {
      onNavegar('detalhes-cliente', { clienteId });
    }
  };

  // Cliente vinculado ao lead (da conversão local ou do clienteId que a busca devolve).
  const clienteIdDoLead = (lead) => clientesConvertidos[lead.id] || lead.clienteId || null;
  const ehConvertido = (lead) => lead.status === 'convertido' || leadsConvertidos.includes(lead.id);

  const ROTULOS_STATUS = {
    novo: 'Novo', qualificado: 'Qualificado', descartado: 'Descartado', convertido: 'Convertido',
  };

  const LOTE_MAX = 50;
  const ROTULOS_ERRO_LOTE = {
    ALREADY_CONVERTED: 'Já convertido',
    ALREADY_CLIENT: 'Documento já é cliente',
    LEAD_NOT_FOUND: 'Lead não encontrado',
    DUPLICATE_LEAD: 'Lead repetido na seleção',
    VALIDATION_ERROR: 'CPF/CNPJ inválido',
  };

  const soDigitos = (doc) => (doc || '').replace(/\D/g, '');
  // Validação igual à conversão single: aceita 11 (CPF) ou 14 (CNPJ) dígitos.
  const documentoValido = (doc) => [11, 14].includes(soDigitos(doc).length);

  const alternarSelecao = (leadId) => {
    setSelecionados((prev) => {
      if (prev.includes(leadId)) {
        return prev.filter((id) => id !== leadId);
      }
      if (prev.length >= LOTE_MAX) {
        return prev; // limite alinhado ao backend
      }
      return [...prev, leadId];
    });
  };

  const abrirModalLote = () => {
    setResultadosLote(null);
    setErroLote(null);
    setModalLoteAberto(true);
  };

  const todosComDocumento = selecionados.length > 0
    && selecionados.every((id) => documentoValido(documentosLote[id]));

  // Conversão em lote (PRD 22 / SEF-30, US-002). Resultado é tratado por item; sucesso/já-convertido
  // marcam o lead local como convertido e saem da seleção; já-cliente só oferece "Ver cliente".
  const converterLote = async () => {
    if (enviandoLote || !todosComDocumento) {
      return;
    }
    setEnviandoLote(true);
    setErroLote(null);
    const itens = selecionados.map((id) => ({ leadId: id, documento: soDigitos(documentosLote[id]) }));
    try {
      const resp = await apiFetch('/api/leads/converter-em-lote', { method: 'POST', body: { itens } });
      const resultados = resp?.resultados ?? [];
      setResultadosLote(resultados);

      const convertidos = [];
      const clienteMap = {};
      resultados.forEach((r) => {
        if (r.success || r.erro === 'ALREADY_CONVERTED') {
          convertidos.push(r.leadId);
          if (r.clienteId) clienteMap[r.leadId] = r.clienteId;
        } else if (r.erro === 'ALREADY_CLIENT' && r.clienteId) {
          clienteMap[r.leadId] = r.clienteId; // só p/ "Ver cliente"; NÃO marca convertido
        }
      });
      if (convertidos.length) {
        setResultados((prev) => prev.map((l) => (
          convertidos.includes(l.id)
            ? { ...l, status: 'convertido', clienteId: clienteMap[l.id] || l.clienteId }
            : l
        )));
        setLeadsConvertidos((prev) => [...new Set([...prev, ...convertidos])]);
      }
      if (Object.keys(clienteMap).length) {
        setClientesConvertidos((prev) => ({ ...prev, ...clienteMap }));
      }
      // remove da seleção os que foram resolvidos como convertidos
      setSelecionados((prev) => prev.filter((id) => !convertidos.includes(id)));
    } catch (e) {
      if (e instanceof ApiError && e.status === 400) {
        setErroLote('Cada lead precisa de um CPF/CNPJ válido (até 50 por lote).');
      } else {
        setErroLote('Não foi possível converter o lote. Tente novamente.');
      }
    } finally {
      setEnviandoLote(false);
    }
  };

  // Qualifica/descarta um lead (PRD 22 / SEF-30, US-003) via PATCH; atualiza só aquele lead na lista.
  const mudarStatus = async (lead, status) => {
    if (statusEmAndamento === lead.id) {
      return; // anti-duplo-clique por lead
    }
    let motivo = null;
    if (status === 'descartado') {
      motivo = window.prompt('Motivo do descarte (opcional):');
      if (motivo === null) {
        return; // cancelado
      }
    }
    const motivoLimpo = motivo && motivo.trim() ? motivo.trim() : null;
    setStatusEmAndamento(lead.id);
    setErroStatus(null);
    try {
      await apiFetch(`/api/leads/${lead.id}/status`, {
        method: 'PATCH',
        body: { status, motivo: motivoLimpo },
      });
      setResultados((prev) => {
        // checkbox desligado: descartar tira o card da lista; ligado, mantém atualizado.
        if (status === 'descartado' && !mostrarDescartados) {
          return prev.filter((l) => l.id !== lead.id);
        }
        return prev.map((l) => (
          l.id === lead.id ? { ...l, status, motivoStatus: motivoLimpo } : l
        ));
      });
    } catch (e) {
      if (e instanceof ApiError && e.code === 'LEAD_ALREADY_CONVERTED') {
        const cid = e.details?.clienteId;
        setResultados((prev) => prev.map((l) => (
          l.id === lead.id ? { ...l, status: 'convertido', clienteId: cid || l.clienteId } : l
        )));
        setErroStatus({ leadId: lead.id, mensagem: 'Este lead já foi convertido em cliente.' });
      } else if (e instanceof ApiError && e.status === 400) {
        setErroStatus({ leadId: lead.id, mensagem: 'Não foi possível alterar o status.' });
      } else {
        setErroStatus({ leadId: lead.id, mensagem: 'Erro ao alterar status. Tente novamente.' });
      }
    } finally {
      setStatusEmAndamento(null);
    }
  };

  const alternarMostrarDescartados = (e) => {
    const novo = e.target.checked;
    setMostrarDescartados(novo);
    if (termoBusca.trim()) {
      realizarBusca(novo);
    }
  };

  // Renderização dos filtros específicos baseado na fonte selecionada
  const renderizarFiltrosEspecificos = () => {
    switch (fonteBusca) {
      case 'google':
        return (
          <div className="filtros-especificos">
            <div className="filtro-grupo">
              <label htmlFor="filtro-regiao">Região</label>
              <select 
                id="filtro-regiao" 
                value={filtroRegiao} 
                onChange={(e) => setFiltroRegiao(e.target.value)}
              >
                <option value="">Todas as regiões</option>
                {estadosBrasileiros.map(estado => (
                  <option key={estado.sigla} value={estado.sigla}>{estado.nome}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-tipo-empresa">Tipo de Empresa</label>
              <select 
                id="filtro-tipo-empresa" 
                value={filtroTipoEmpresa} 
                onChange={(e) => setFiltroTipoEmpresa(e.target.value)}
              >
                <option value="">Todos os tipos</option>
                {tiposEmpresa.map(tipo => (
                  <option key={tipo.valor} value={tipo.valor}>{tipo.rotulo}</option>
                ))}
              </select>
            </div>
          </div>
        );
        
      case 'inpi':
        return (
          <div className="filtros-especificos">
            <div className="filtro-grupo">
              <label htmlFor="filtro-regiao">Região</label>
              <select 
                id="filtro-regiao" 
                value={filtroRegiao} 
                onChange={(e) => setFiltroRegiao(e.target.value)}
              >
                <option value="">Todas as regiões</option>
                {estadosBrasileiros.map(estado => (
                  <option key={estado.sigla} value={estado.sigla}>{estado.nome}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-classe">Classe INPI</label>
              <select 
                id="filtro-classe" 
                value={filtroClasse} 
                onChange={(e) => setFiltroClasse(e.target.value)}
              >
                <option value="">Todas as classes</option>
                {classesINPI.map(classe => (
                  <option key={classe.numero} value={classe.numero}>
                    {classe.numero} - {classe.descricao}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-data-registro">Data de Depósito</label>
              <input 
                type="date" 
                id="filtro-data-registro" 
                value={filtroDataRegistro} 
                onChange={(e) => setFiltroDataRegistro(e.target.value)} 
              />
            </div>
          </div>
        );
        
      case 'receita':
        return (
          <div className="filtros-especificos">
            <div className="filtro-grupo">
              <label htmlFor="filtro-regiao">Região</label>
              <select 
                id="filtro-regiao" 
                value={filtroRegiao} 
                onChange={(e) => setFiltroRegiao(e.target.value)}
              >
                <option value="">Todas as regiões</option>
                {estadosBrasileiros.map(estado => (
                  <option key={estado.sigla} value={estado.sigla}>{estado.nome}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-tipo-empresa">Tipo de Empresa</label>
              <select 
                id="filtro-tipo-empresa" 
                value={filtroTipoEmpresa} 
                onChange={(e) => setFiltroTipoEmpresa(e.target.value)}
              >
                <option value="">Todos os tipos</option>
                {tiposEmpresa.map(tipo => (
                  <option key={tipo.valor} value={tipo.valor}>{tipo.rotulo}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-cnae">CNAE</label>
              <select 
                id="filtro-cnae" 
                value={filtroCnae} 
                onChange={(e) => setFiltroCnae(e.target.value)}
              >
                <option value="">Todos os CNAEs</option>
                {principaisCnaes.map(cnae => (
                  <option key={cnae.codigo} value={cnae.codigo}>
                    {cnae.codigo} - {cnae.descricao}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label htmlFor="filtro-data-abertura">Data de Abertura</label>
              <input 
                type="date" 
                id="filtro-data-abertura" 
                value={filtroDataRegistro} 
                onChange={(e) => setFiltroDataRegistro(e.target.value)} 
              />
            </div>
          </div>
        );
        
      default:
        return null;
    }
  };

  // Renderizar detalhes específicos baseado na fonte do lead
  const renderizarDetalhesLead = (lead) => {
    switch (lead.fonte) {
      case 'inpi':
        return (
          <div className="lead-detalhes-especificos">
            <div className="detalhe-item">
              <span className="detalhe-label">Nº Processo:</span>
              <span className="detalhe-valor">{lead.numeroProcesso || '—'}</span>
            </div>
            {lead.classe && (
              <div className="detalhe-item">
                <span className="detalhe-label">Classe:</span>
                <span className="detalhe-valor">{lead.classe}</span>
              </div>
            )}
            {lead.dataDeposito && (
              <div className="detalhe-item">
                <span className="detalhe-label">Data de Depósito:</span>
                <span className="detalhe-valor">{new Date(lead.dataDeposito).toLocaleDateString('pt-BR')}</span>
              </div>
            )}
            <div className="detalhe-item">
              <span className="detalhe-label">Situação:</span>
              <span className="detalhe-valor">{lead.situacao || '—'}</span>
            </div>
          </div>
        );

      case 'receita':
        return (
          <div className="lead-detalhes-especificos">
            <div className="detalhe-item">
              <span className="detalhe-label">CNPJ:</span>
              <span className="detalhe-valor">{lead.cnpj}</span>
            </div>
            <div className="detalhe-item">
              <span className="detalhe-label">Data de Abertura:</span>
              <span className="detalhe-valor">{new Date(lead.dataAbertura).toLocaleDateString('pt-BR')}</span>
            </div>
            <div className="detalhe-item">
              <span className="detalhe-label">CNAE:</span>
              <span className="detalhe-valor">{lead.cnae}</span>
            </div>
          </div>
        );
        
      default:
        return (
          <div className="lead-detalhes-especificos">
            <div className="detalhe-item">
              <span className="detalhe-label">Verificado:</span>
              <span className="detalhe-valor">{lead.verificado ? 'Sim' : 'Não'}</span>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="leads-container">
      <div className="leads-header">
        <div>
          <h1>Busca de Leads</h1>
          <p className="descricao">Encontre novos leads potenciais para prospecção</p>
        </div>
        {onNavegar && (
          <button type="button" className="link-historico-leads" onClick={() => onNavegar('leads-historico')}>
            <i className="fa-solid fa-clock-rotate-left" aria-hidden="true"></i> Histórico de leads
          </button>
        )}
      </div>
      
      {/* Seleção de fonte de busca */}
      <div className="fontes-container">
        <div 
          className={`fonte-item ${fonteBusca === 'google' ? 'ativo' : ''}`}
          onClick={() => setFonteBusca('google')}
        >
          <div className="fonte-icone google-icon">
            <img src="/icons/google-maps.svg" alt="Google Maps" />
          </div>
          <span>Google Maps</span>
          <p className="fonte-descricao">Busque empresas locais que podem precisar de serviços de PI</p>
        </div>
        
        <div 
          className={`fonte-item ${fonteBusca === 'inpi' ? 'ativo' : ''}`}
          onClick={() => setFonteBusca('inpi')}
        >
          <div className="fonte-icone inpi-icon">
            <img src="/icons/inpi.svg" alt="INPI" />
          </div>
          <span>Base INPI</span>
          <p className="fonte-descricao">Encontre empresas que registraram marcas sem procurador profissional</p>
        </div>
        
        <div 
          className={`fonte-item ${fonteBusca === 'receita' ? 'ativo' : ''}`}
          onClick={() => setFonteBusca('receita')}
        >
          <div className="fonte-icone receita-icon">
            <img src="/icons/receita-federal.svg" alt="Receita Federal" />
          </div>
          <span>Receita Federal</span>
          <p className="fonte-descricao">Descubra novos CNPJs recém-abertos que podem precisar de proteção de marca</p>
        </div>
      </div>
      
      {/* Filtros de busca */}
      <div className="filtros-container busca-leads">
        <div className="filtro-principal">
          <div className="campo-busca">
            <input
              type="text"
              placeholder={`Buscar em ${fonteBusca === 'google' ? 'Google Maps' : fonteBusca === 'inpi' ? 'Base INPI' : 'Receita Federal'}...`}
              value={termoBusca}
              onChange={(e) => setTermoBusca(e.target.value)}
            />
            <button
              className="botao-buscar"
              onClick={() => realizarBusca()}
              disabled={carregando}
            >
              {carregando ? 'Buscando...' : 'Buscar'}
            </button>
          </div>

          <label className="busca-mostrar-descartados">
            <input
              type="checkbox"
              checked={mostrarDescartados}
              onChange={alternarMostrarDescartados}
            />
            Mostrar descartados
          </label>
          
          {/* Filtros por fonte são US-002 (follow-up); desabilitados para não parecer que filtram. */}
          <button
            className="botao-filtros-avancados"
            onClick={() => setMostrarFiltrosAvancados(!mostrarFiltrosAvancados)}
            disabled
            title="Filtros por fonte chegam na US-002"
          >
            Filtros avançados (em breve)
          </button>
        </div>
        
        {mostrarFiltrosAvancados && (
          <>
            {renderizarFiltrosEspecificos()}
            
            <div className="acoes-filtros">
              <button className="limpar-filtros" onClick={limparFiltros}>
                Limpar Filtros
              </button>
              <button className="aplicar-filtros" onClick={() => realizarBusca()}>
                Aplicar Filtros
              </button>
            </div>
          </>
        )}
      </div>
      
      {erro && (
        <div className="busca-leads-aviso" role="status">{erro}</div>
      )}

      {/* Lista de Resultados */}
      {carregando ? (
        <EstadoCarregando mensagem="Buscando leads..." />
      ) : resultados.length > 0 ? (
        <div className="resultados-container">
          <h2>Resultados da Busca</h2>
          {selecionados.length > 0 && (
            <div className="barra-selecao-lote">
              <span>{selecionados.length} selecionado{selecionados.length > 1 ? 's' : ''}
                {selecionados.length >= LOTE_MAX ? ' (máximo)' : ''}</span>
              <div className="barra-selecao-acoes">
                <button type="button" className="botao-limpar-selecao" onClick={() => setSelecionados([])}>
                  Limpar
                </button>
                <button type="button" className="botao-converter-lote" onClick={abrirModalLote}>
                  Converter em lote ({selecionados.length})
                </button>
              </div>
            </div>
          )}
          <div className="lista-leads">
            {resultados.map(lead => (
              <div className="cartao-lead" key={lead.id}>
                <div className="lead-cabecalho">
                  <h3 className="lead-nome">{lead.nome}</h3>
                  <div className="lead-cabecalho-tags">
                    {lead.jaCliente && (
                      <span className="lead-ja-cliente" title="Já é cliente do escritório">Já é cliente</span>
                    )}
                    <span className={`lead-tipo ${lead.tipo || ''}`}>
                      {tiposEmpresa.find(t => t.valor === lead.tipo)?.rotulo
                        || (lead.tipo ? lead.tipo.toUpperCase() : '—')}
                    </span>
                    <span className={`lead-status-badge status-${lead.status || 'novo'}`}>
                      {ROTULOS_STATUS[lead.status] || 'Novo'}
                    </span>
                  </div>
                </div>
                
                <div className="lead-corpo">
                  <div className="lead-detalhes-principais">
                    <div className="detalhe-item">
                      <span className="detalhe-label">Endereço:</span>
                      <span className="detalhe-valor">{lead.endereco}</span>
                    </div>
                    <div className="detalhe-item">
                      <span className="detalhe-label">Contato:</span>
                      <span className="detalhe-valor">{lead.telefone}</span>
                    </div>
                    <div className="detalhe-item">
                      <span className="detalhe-label">Email:</span>
                      <span className="detalhe-valor">{lead.email}</span>
                    </div>
                    <div className="detalhe-item">
                      <span className="detalhe-label">Ramo:</span>
                      <span className="detalhe-valor">{lead.ramo}</span>
                    </div>
                    <div className="detalhe-item">
                      <span className="detalhe-label">Potencial:</span>
                      <span className="detalhe-valor potencial">{lead.potencialNecessidade}</span>
                    </div>
                    <div className="detalhe-item">
                      <span className="detalhe-label">Fonte:</span>
                      <span className="detalhe-valor fonte">{lead.fonte}</span>
                    </div>
                  </div>
                  
                  {renderizarDetalhesLead(lead)}
                  {lead.status === 'descartado' && lead.motivoStatus && (
                    <p className="lead-motivo-descarte">Motivo do descarte: {lead.motivoStatus}</p>
                  )}
                </div>

                <div className="lead-acoes">
                  {ehConvertido(lead) ? (
                    <>
                      <span className="lead-acao-convertido">Convertido</span>
                      {clienteIdDoLead(lead) && onNavegar && (
                        <button
                          type="button"
                          className="botao-ver-cliente"
                          onClick={() => onNavegar('detalhes-cliente', { clienteId: clienteIdDoLead(lead) })}
                        >
                          Ver cliente
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      <label className="lead-selecionar" title="Selecionar para conversão em lote">
                        <input
                          type="checkbox"
                          checked={selecionados.includes(lead.id)}
                          onChange={() => alternarSelecao(lead.id)}
                        />
                        Selecionar
                      </label>
                      <button
                        className="botao-converter"
                        onClick={() => abrirModalConversao(lead)}
                        disabled={statusEmAndamento === lead.id}
                      >
                        Converter em Cliente
                      </button>
                      <button
                        type="button"
                        className="botao-qualificar"
                        onClick={() => mudarStatus(lead, 'qualificado')}
                        disabled={statusEmAndamento === lead.id || lead.status === 'qualificado'}
                      >
                        {statusEmAndamento === lead.id ? '...' : 'Qualificar'}
                      </button>
                      <button
                        type="button"
                        className="botao-descartar"
                        onClick={() => mudarStatus(lead, 'descartado')}
                        disabled={statusEmAndamento === lead.id}
                      >
                        Descartar
                      </button>
                    </>
                  )}
                  {erroStatus?.leadId === lead.id && (
                    <span className="status-erro" role="alert">{erroStatus.mensagem}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : termoBusca || filtroRegiao || filtroTipoEmpresa || filtroCnae || filtroDataRegistro || filtroClasse ? (
        <EstadoVazio
          icone="fa-solid fa-magnifying-glass"
          titulo="Nenhum resultado encontrado"
          descricao="Não foram encontrados leads com os filtros aplicados. Tente modificar os critérios de busca ou expandir sua área de busca."
          acao={{ rotulo: 'Limpar Filtros', onClick: limparFiltros }}
        />
      ) : (
        <div className="estado-inicial">
          <div className="ilustracao-busca">
            <i className="fas fa-search"></i>
          </div>
          <h3>Inicie sua busca por leads</h3>
          <p>
            Selecione uma fonte de busca, defina seus filtros e clique em "Buscar"
            para encontrar novos leads potenciais.
          </p>
        </div>
      )}
      
      {/* Modal de Conversão de Lead */}
      {modalConversaoAberto && leadAtual && (
        <div className="modal-overlay" onClick={fecharModalConversao}>
          <div className="modal-conteudo" onClick={(e) => e.stopPropagation()}>
            <div className="modal-cabecalho">
              <h2>Converter Lead em Cliente</h2>
              <button className="modal-fechar" onClick={fecharModalConversao}>×</button>
            </div>
            
            <div className="modal-corpo">
              <div className="confirmar-conversao">
                <p>
                  Você está prestes a converter o lead <strong>{leadAtual.nome}</strong> em um cliente.
                  Os dados abaixo serão transferidos para o cadastro de cliente.
                </p>
                
                <div className="lead-dados-conversao">
                  <div className="dado-conversao">
                    <span className="dado-label">Nome/Razão Social:</span>
                    <span className="dado-valor">{leadAtual.nome}</span>
                  </div>
                  <div className="dado-conversao">
                    <span className="dado-label">Tipo:</span>
                    <span className="dado-valor">{tiposEmpresa.find(t => t.valor === leadAtual.tipo)?.rotulo || leadAtual.tipo.toUpperCase()}</span>
                  </div>
                  <div className="dado-conversao">
                    <span className="dado-label">Endereço:</span>
                    <span className="dado-valor">{leadAtual.endereco}</span>
                  </div>
                  <div className="dado-conversao">
                    <span className="dado-label">Telefone:</span>
                    <span className="dado-valor">{leadAtual.telefone}</span>
                  </div>
                  <div className="dado-conversao">
                    <span className="dado-label">Email:</span>
                    <span className="dado-valor">{leadAtual.email}</span>
                  </div>
                  
                  {leadAtual.fonte === 'Receita Federal' && (
                    <div className="dado-conversao">
                      <span className="dado-label">CNPJ:</span>
                      <span className="dado-valor">{leadAtual.cnpj}</span>
                    </div>
                  )}
                </div>

                <div className="conversao-form">
                  <div className="form-grupo">
                    <label htmlFor="conversao-documento">CPF/CNPJ do cliente *</label>
                    <input
                      id="conversao-documento"
                      type="text"
                      value={documentoConversao}
                      onChange={(e) => setDocumentoConversao(e.target.value)}
                      placeholder="Somente números"
                    />
                    <small>O lead do INPI não traz documento; informe o CPF/CNPJ para criar o cliente.</small>
                  </div>
                  <div className="form-grupo">
                    <label htmlFor="conversao-observacoes">Observações</label>
                    <textarea
                      id="conversao-observacoes"
                      value={observacoesConversao}
                      onChange={(e) => setObservacoesConversao(e.target.value)}
                    />
                  </div>
                  {erroConversao && <p className="conversao-erro" role="alert">{erroConversao}</p>}
                  {erroConversao && clientesConvertidos[leadAtual.id] && onNavegar && (
                    <button
                      type="button"
                      className="botao-ver-cliente"
                      onClick={() => abrirCliente(leadAtual.id)}
                    >
                      Ver cliente
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-rodape">
              <button className="botao-cancelar" onClick={fecharModalConversao} disabled={convertendo}>
                Cancelar
              </button>
              <button
                className="botao-salvar"
                onClick={converterLead}
                disabled={convertendo || !documentoConversao.trim()}
              >
                {convertendo ? 'Convertendo...' : 'Converter em Cliente'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de revisão da conversão em lote (PRD 22 / SEF-30, US-002) */}
      {modalLoteAberto && (
        <div className="modal-overlay" onClick={() => setModalLoteAberto(false)}>
          <div className="modal-conteudo modal-lote" onClick={(e) => e.stopPropagation()}>
            <div className="modal-cabecalho">
              <h2>Converter {selecionados.length} lead{selecionados.length > 1 ? 's' : ''} em lote</h2>
              <button className="modal-fechar" onClick={() => setModalLoteAberto(false)}>×</button>
            </div>
            <div className="modal-corpo">
              <p className="modal-lote-instrucao">
                Informe o CPF/CNPJ de cada lead. Leads do INPI não trazem documento — preencha antes de converter.
              </p>
              {selecionados.map((id) => {
                const lead = resultados.find((l) => l.id === id);
                const invalido = documentosLote[id] && !documentoValido(documentosLote[id]);
                return (
                  <div className="lote-item" key={id}>
                    <span className="lote-item-nome">{lead?.nome || id}</span>
                    <input
                      type="text"
                      aria-label={`Documento de ${lead?.nome || id}`}
                      placeholder="CPF ou CNPJ"
                      value={documentosLote[id] || ''}
                      onChange={(e) => setDocumentosLote((prev) => ({ ...prev, [id]: e.target.value }))}
                      className={invalido ? 'documento-invalido' : ''}
                    />
                  </div>
                );
              })}

              {resultadosLote && (
                <div className="lote-resumo">
                  <h3>Resultado</h3>
                  {resultadosLote.map((r) => {
                    const lead = resultados.find((l) => l.id === r.leadId);
                    return (
                      <div className={`lote-resultado ${r.success ? 'ok' : 'erro'}`} key={r.leadId}>
                        <span className="lote-resultado-nome">{lead?.nome || r.leadId}</span>
                        {r.success ? (
                          <span className="lote-ok">✓ Convertido</span>
                        ) : (
                          <span className="lote-erro">{ROTULOS_ERRO_LOTE[r.erro] || r.erro}</span>
                        )}
                        {r.clienteId && onNavegar && (
                          <button
                            type="button"
                            className="botao-ver-cliente"
                            onClick={() => onNavegar('detalhes-cliente', { clienteId: r.clienteId })}
                          >
                            Ver cliente
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {erroLote && <p className="status-erro" role="alert">{erroLote}</p>}
            </div>
            <div className="modal-rodape">
              <button className="botao-cancelar" onClick={() => setModalLoteAberto(false)}>Fechar</button>
              <button
                className="botao-salvar"
                onClick={converterLote}
                disabled={enviandoLote || !todosComDocumento}
              >
                {enviandoLote ? 'Convertendo...' : `Converter ${selecionados.length}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BuscaLeads; 